import { ObservationService } from '../../../../observation/observation.service';
import { NavigationService } from '../../../../navigation/navigation.service';
import { ProfileSearchService } from '../../../../../profiles/search/profile-search.service';
import { ProfileAdvancedSearchParams } from '../../../../../profiles/search/profile-advanced-search-params.model';
import { InvoiceService } from '../../../../../revenue/shared/invoice/invoice.service';
import { SerialSearchExpression } from '../../../../search-expression/serial-search-expression.model';
import { InvoiceAdvancedSearch } from '../../../../../revenue/shared/invoice/invoice-advanced-search.model';
import { UtilService } from '../../../../util/util.service';
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { FieldValueOperatorEnum } from 'src/app/shared/search-expression/field-value-operator.enum';
import { AutoComplete } from 'primeng/autocomplete';

@Component({
  selector: 'wl-module-revenue-toolbar',
  templateUrl: './toolbar-module-revenue.component.html',
  styleUrls: ['./toolbar-module-revenue.component.less'],
  encapsulation: ViewEncapsulation.None,
  providers: [ProfileSearchService],
    standalone: false
})
export class ToolbarModuleRevenueComponent implements OnInit {
  selectedResult: SearchResult;
  isInvoiceNumSearch: boolean;
  searchResults: SearchResult[] = [];
  showNewInvoice: boolean;
  showNewPayment: boolean;

  @ViewChild(AutoComplete) autocompleteComponent: AutoComplete;

  constructor(
    private _utilService: UtilService,
    private _invoiceService: InvoiceService,
    private _profileSearchService: ProfileSearchService,
    private _navigationService: NavigationService,
    private _observationService: ObservationService
  ) {}

  ngOnInit() {
    this._observationService.observeApplyBatchPayment().subscribe(() => {
      this.showNewPayment = true;
    });
  }

  search(event: any) {
    const query: string = event.query;
    if (this._utilService.isNumeric(query)) {
      this.isInvoiceNumSearch = true;
      const invoiceSearchParams = new InvoiceAdvancedSearch();
      invoiceSearchParams.InvoiceInfoSearchExpressions = [
        { Field: 'InvoiceNum', Value: query, FieldValueOperator: FieldValueOperatorEnum.Contains } as SerialSearchExpression,
      ];
      this._invoiceService.advancedSearch(invoiceSearchParams).then((pagedResult) => {
        this.searchResults = [];
        pagedResult.Result.forEach((invoiceResult) => {
          this.searchResults.push({
            display: `${invoiceResult.ProfileReportName} (${invoiceResult.InvoiceNum})`,
            invoiceNum: invoiceResult.InvoiceNum,
            //command: () => this._navigationService.navigateToInvoiceEdit(invoiceResult.InvoiceNum),
          } as SearchResult);
        });
      });
    } else {
      this.isInvoiceNumSearch = false;
      const profileSearchParams = new ProfileAdvancedSearchParams();
      profileSearchParams.Keyword = query;
      this._profileSearchService.advancedSearch(profileSearchParams).then((searchResult) => {
        this.searchResults = [];
        searchResult.Result.forEach((profileResult) => {
          this.searchResults.push({
            display: `${profileResult.ReportName}`,
            profileId: profileResult.ProfileId,
            //command: () => this._navigationService.navigateToTransactionsView(profileResult.ProfileId),
          } as SearchResult);
        });
      });
    }
  }

  clear() {
    this.searchResults = [];
    this.selectedResult = null;
  }

  public autocompleteInvoiceSelected = ($event: any) => {
    this.selectedResult.invoiceNum
      ? this._navigationService.navigateToInvoiceEdit(this.selectedResult.invoiceNum)
      : this._navigationService.navigateToTransactionsView(this.selectedResult.profileId);
  };
}

interface SearchResult {
  display: string;
  profileId: number;
  invoiceNum: number;
}
